import { render, staticRenderFns } from "./tax-rules.vue?vue&type=template&id=6e1ca3e4&"
import script from "./tax-rules.vue?vue&type=script&lang=js&"
export * from "./tax-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports